import React from 'react';
import { Link } from 'react-router-dom';
import { Github, BookOpen } from 'lucide-react';

const Header: React.FC = () => {
  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 hover:opacity-90 transition-opacity">
            <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-purple-600 rounded-xl flex items-center justify-center">
              <span className="text-white font-bold text-lg">A</span>
            </div>
            <div>
              <h1 className="text-xl font-bold text-gray-900">AllTools</h1>
              <p className="text-xs text-gray-500">Free Online Utilities</p>
            </div>
          </Link>

          {/* Navigation */}
          <nav className="flex items-center space-x-4 md:space-x-8">
            <Link to="/" className="text-gray-600 hover:text-gray-900 transition-colors text-sm md:text-base">
              Tools
            </Link>
            <Link to="/blog" className="text-gray-600 hover:text-gray-900 transition-colors text-sm md:text-base flex items-center gap-1">
              <BookOpen className="w-4 h-4 hidden md:block" /> Blog
            </Link>
            <a
              href="https://github.com/DanGatobu"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 text-gray-400 hover:text-gray-600 transition-colors"
              aria-label="GitHub"
            >
              <Github className="w-5 h-5" />
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
